import { InformeTableDataDtoProps } from "./DTOs/InformeTableDataDto"

export const BalanceSituacionByFilterAdapter = (
  balanceSituacion: InformeTableDataDtoProps
): InformeTableDataDtoProps => {
  return {
    items: balanceSituacion?.items,
    tableColumns: balanceSituacion?.tableColumns,
  }
}
